<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-progress-linear
        indeterminate
        :active="isRequestingNow.length > 0"
        color="blue"
        class="mb-0"
      ></v-progress-linear>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex style="position: relative">
        <v-container class="grey lighten-5">
          <v-form
            ref="form"
            autocomplete="off"
            method="post"
            action=""
          >
            <v-row class="mt-5">
              <v-col cols="12">
                <b>{{ $t('cleaners.stock_events.actual_balances') }}: </b>
                ({{ $t('cleaners.stock_events.managed_in_the_cleaner_personal_account') }})
              </v-col>
              <v-col cols="12">
                <div v-if="currentStockItems.length">
                  <table class="tableStockEvents">
                    <tr>
                      <th>{{ $t('table.headers.product') }}</th>
                      <th>{{ $t('table.headers.actual_qty') }}</th>
                      <th>{{ $t('table.headers.note') }}</th>
                    </tr>
                    <tr :key="currentStockItem.id" v-for="currentStockItem in currentStockItems">
                      <td>
                        <div><b>{{currentStockItem.name}}</b></div>
                      </td>
                      <td>{{(currentStockItem.data.balance/100).toFixed(2)}}</td>
                      <td>{{currentStockItem.data.note}}</td>
                    </tr>
                  </table>
                </div>
              </v-col>
              <v-col cols="12">
                <b>{{ $t('cleaners.stock_events.warehouse_history') }}: </b>
              </v-col>
              <v-col cols="12">
                <div v-if="paginatedObject.data && paginatedObject.data.length">
                  <table class="tableStockEvents">
                    <tr>
                      <th>{{ $t('table.headers.product') }}</th>
                      <th>{{ $t('table.headers.actual_qty') }}</th>
                      <th>{{ $t('table.headers.note') }}</th>
                      <th>{{ $t('table.headers.data') }}</th>
                    </tr>
                    <tr :key="event.id" v-for="event in paginatedObject.data">
                      <td>
                        <template v-if="event.item">
                          <div><b>{{event.item.name}}</b></div>
                          <div v-if="event.item.note">({{event.item.note}})</div>
                          <div v-if="event.item.deleted_at" style="color: red">
                            {{ $t('cleaners.stock_events.warehouse_removed') }}
                          </div>
                        </template>
                      </td>
                      <td>{{(event.amount/100).toFixed(2)}}</td>
                      <td>{{event.note}}</td>
                      <td>
                        <div>{{ $t('cleaners.stock_events.data') }}:
                          {{moment.utc(event.created_at).local().format(DATETIME_VIEW)}} <small
                            v-if="event.data.user">({{ event.data.user.name }})</small>
                        </div>
                        <div v-if="event.data.cleaner">
                          {{ $t('cleaners.stock_events.recipient') }}: {{ event.data.cleaner.name }}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </v-col>
              <v-col cols="12">
                <pagination-listing
                  :pagination-data="paginationData"
                  @go-prev="changePage('-')"
                  @go-next="changePage('+')"
                ></pagination-listing>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import validationMixin from '@/mixins/validationMixin';
import StockItemProxy from '@/proxies/Stock/StockItemProxy';
import paginationMixin from '@/mixins/listing/paginationMixin';
import PaginationListing from '@/components/listings/PaginationListing.vue';
import { PER_PAGE_ORDERS } from '@/constants/listing';
import { DATETIME_VIEW } from '@/constants/dates';

export default {
  name: 'StoreItemShow',
  mixins: [
    updatePageContentMixin,
    validationMixin,
    paginationMixin,
  ],
  components: {
    PaginationListing,
  },
  data() {
    return {
      moment,
      DATETIME_VIEW,
      pageLoading: false,
      isRequestingNow: [],
      errors: {},
      updatingData: {},
      currentEditableItem: {},
      measureItems: [],
      currentStockItems: [],
      searchParams: {
        page: {
          number: 1,
          size: PER_PAGE_ORDERS,
        },
      },
    };
  },
  created() {
    this.pageLoading = true;
    this.fetchData();
  },
  watch: {
    '$route.params.uuid': {
      handler() {
        this.fetchData();
      },
    },
    searchParams: {
      handler() {
        this.fetchEventsData();
      },
      deep: true,
    },
  },
  methods: {
    fetchData() {
      new StockItemProxy()
        .amountByCleanerListing(this.$route.params.uuid)
        .then((response) => {
          this.currentStockItems = response.data.data.items;
        })
        .catch((error) => {
          this.currentStockItems = [];
        });

      new StockItemProxy()
        .setParameters(this.searchParams)
        .eventsByCleanerListing(this.$route.params.uuid)
        .then((response) => {
          this.paginatedObject = response.data.data.items;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.pageLoading = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .tableStockEvents {
    width: 100%;
    border-spacing: 0;

    th {
      border: 1px solid #dddddd;
    }

    td {
      border: 1px solid #dddddd;
    }
  }
</style>
